import HeaderSignOut from "../../../../components/headers/HeaderSignOut";
import InputPhoneNumStep from "./0_InputPhoneNumStep";
import ConfirmPhoneNumStep from "./1_ConfirmPhoneNumStep";
import { Stepper, Step, StepLabel, Box, Container } from "@mui/material";
import React, { useState } from "react";

const stepNames: string[] = ["電話番号入力", "認証コード入力"];

const PhoneNumChangeStepperPage: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);

  const handleNextStep: () => void = (): void => {
    setActiveStep((prevActiveStep: number): number => prevActiveStep + 1);
  };

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <InputPhoneNumStep onNext={handleNextStep} />;
      case 1:
        return <ConfirmPhoneNumStep />;
      default:
        return null;
    }
  };

  return (
    <>
      <HeaderSignOut />
      <Container maxWidth="sm">
        <Box mt={5}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {stepNames.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box mt={4}>{renderStepContent(activeStep)}</Box>
        </Box>
      </Container>
    </>
  );
};

export default PhoneNumChangeStepperPage;
